import { config } from '@skytech/config'

export async function customFetch<R = any>({
  path,
  headers = {},
  method = 'GET',
  data,
  environment,
  credentials,
}: RequestInit & {
  path: string
  data?: unknown
  environment?: string
  headers?: Record<string, string>
}): Promise<R> {
  const fetchHeaders = {
    ...headers,
  }

  if (['POST', 'PUT', 'PATCH'].includes(method)) {
    fetchHeaders['content-type'] = headers['content-type'] || 'application/json'
  }

  const response = await fetch((environment || config.API_URL) + path, {
    method,
    mode: 'cors',
    credentials,
    body: data ? JSON.stringify(data) : undefined,
    headers: fetchHeaders,
  })

  if (!response.ok) {
    const [text, json] = await Promise.all([
      response.text().catch(() => ''),
      response.json().catch(() => {}),
    ])

    throw {
      response,
      text,
      json,
    }
  }

  return await response.json()
}
